
export default class GlobalVar{ //Variaveis Globais
  static serverIp = 'https://apirevendedoratime.babita.com.br'
  static serverPort = '' 

  static getLocalStorage(chave){
    let valor = sessionStorage.getItem(chave)
    return valor !== "undefined" && valor ? JSON.parse(valor) : null
  }

  static setLocalStorage(chave, valor){
    return sessionStorage.setItem(chave,JSON.stringify(valor));
  }
}

